import React, { useState } from 'react';
import { Check, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'premium' | 'mega'>('premium');
  const basicLink = 'https://checkout.kitonline.shop/cart/47657878585582:1';
  const premiumLink = 'https://checkout.kitonline.shop/cart/47657882288366:1';
  const megaLink = 'https://checkout.kitonline.shop/cart/47751669514478:1';
  const getCheckoutLink = () => {
    if (selectedPack === 'basic') return basicLink;
    if (selectedPack === 'premium') return premiumLink;
    return megaLink;
  };
  return <section id="pricing" className="bg-[#0a0e27] py-4 md:py-6 px-4 font-sans" data-id="element-172">
      <div className="max-w-5xl mx-auto" data-id="element-173">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white text-center italic mb-4" data-id="element-174">
          Elegí tu Pack Completo
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 max-w-4xl mx-auto mb-4" data-id="element-175">
          {/* Basic Pack */}
          <div onClick={() => setSelectedPack('basic')} className={`relative bg-[#111638] rounded-lg p-2 pt-2.5 text-center cursor-pointer transition-all duration-300 border-2 ${selectedPack === 'basic' ? 'border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border-gray-800 hover:border-gray-700'}`} data-id="element-176">
            <div className="absolute top-1.5 right-1.5" data-id="element-177">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-178">
                {selectedPack === 'basic' && <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-179" />}
              </div>
            </div>
            <div className="text-3xl mb-0.5" data-id="element-180">📚</div>
            <h3 className="text-xl font-bold text-white italic mb-0" data-id="element-181">
              Kit Completo
            </h3>
            <p className="text-gray-400 text-xs mb-0.5" data-id="element-182">Psicología</p>
            <p className="text-gray-500 text-[10px] mb-0.5" data-id="element-183">6 tomos + Bonus</p>
            <div className="text-4xl font-black text-white tracking-tight leading-none" data-id="element-184">
              $19.990
            </div>
            <div className="text-gray-500 line-through text-sm font-medium decoration-red-500/50 decoration-2" data-id="element-185">
              $39.990
            </div>
          </div>

          {/* Premium Pack */}
          <div onClick={() => setSelectedPack('premium')} className={`relative bg-[#111638] rounded-lg p-2 pt-2.5 text-center cursor-pointer transition-all duration-300 border-2 ${selectedPack === 'premium' ? 'border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border-gray-800 hover:border-gray-700'}`} data-id="element-186">
            <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 bg-[#22c55e] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-187">
              ⭐ Más elegido
            </div>
            <div className="absolute top-1.5 right-1.5" data-id="element-188">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'premium' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-189">
                {selectedPack === 'premium' && <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-190" />}
              </div>
            </div>
            <div className="text-3xl mb-0.5" data-id="element-191">👑</div>
            <h3 className="text-xl font-bold text-white italic mb-0" data-id="element-192">
              Pack Premium
            </h3>
            <p className="text-gray-400 text-xs mb-0.5" data-id="element-193">
              Kit Completo + Sistema Pro de Evaluación
            </p>
            <p className="text-gray-500 text-[10px] mb-0.5" data-id="element-194">6 tomos + Bonus</p>
            <div className="text-4xl font-black text-white tracking-tight leading-none" data-id="element-195">
              $26.990
            </div>
            <div className="text-gray-500 line-through text-sm font-medium decoration-red-500/50 decoration-2" data-id="element-196">
              $49.990
            </div>
          </div>

          {/* Mega Pack */}
          <div onClick={() => setSelectedPack('mega')} className={`relative bg-[#111638] rounded-lg p-2 pt-2.5 text-center cursor-pointer transition-all duration-300 border-2 ${selectedPack === 'mega' ? 'border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border-gray-800 hover:border-gray-700'}`} data-id="element-197">
            <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-black text-[10px] font-bold px-2.5 py-0.5 rounded-full flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-198">
              🔥 Mejor valor
            </div>
            <div className="absolute top-1.5 right-1.5" data-id="element-199">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'mega' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-200">
                {selectedPack === 'mega' && <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-201" />}
              </div>
            </div>
            <div className="text-3xl mb-0.5" data-id="element-202">💎</div>
            <h3 className="text-xl font-bold text-white italic mb-0" data-id="element-203">
              Pack Premium
            </h3>
            <p className="text-gray-400 text-xs mb-0.5" data-id="element-204">
              Psicología Lista + Filosofía Lista
            </p>
            <p className="text-gray-500 text-[10px] mb-0.5" data-id="element-205">
              6 tomos de cada pack + Bonus
            </p>
            <div className="text-4xl font-black text-white tracking-tight leading-none" data-id="element-206">
              $37.990
            </div>
            <div className="text-gray-500 line-through text-sm font-medium decoration-red-500/50 decoration-2" data-id="element-207">
              $64.990
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mb-4" data-id="element-208">
          <CTAButton href={getCheckoutLink()} className="w-full max-w-md py-3 text-xl italic shadow-[0_0_20px_rgba(34,197,94,0.3)] mb-1.5" data-id="element-209">
            Sí, quiero mi pack →
          </CTAButton>
          <div className="flex items-center justify-center gap-2 text-gray-500 text-xs font-medium uppercase tracking-wider" data-id="element-210">
            <Lock className="w-3 h-3" data-id="element-211" /> Pago seguro con Mercado Pago
          </div>
        </div>

        {/* Pack Includes */}
        <div className="max-w-2xl mx-auto bg-[#111638] border border-gray-800 rounded-lg p-3 md:p-4 mb-3 shadow-xl" data-id="element-212">
          <h4 className="text-white font-bold text-center mb-2 uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-213">
            👑 PACK COMPLETO INCLUYE:
          </h4>
          <ul className="space-y-1.5" data-id="element-214">
            {['Kit completo de Psicología para secundaria', 'Secuencias didácticas completas por unidad', 'BONUS: Planificación Anual Lista', 'BONUS: Banco de Dinámicas Psicológicas para el Aula', 'Entrega inmediata por Drive (PDF)', 'Acceso de por vida — sin vencimiento', 'Garantía de satisfacción de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-215">
                <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-216">
                  <Check className="w-3 h-3 text-white" strokeWidth={4} data-id="element-217" />
                </div>
                <span className="text-gray-300 text-sm md:text-base" data-id="element-218">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Payment Methods */}
        <div className="flex justify-center" data-id="element-219">
          <div className="inline-flex items-center gap-2 border border-gray-800 rounded-full px-4 py-1.5 text-gray-500 text-xs md:text-sm" data-id="element-220">
            <CreditCard className="w-3.5 h-3.5" data-id="element-221" />
            <span data-id="element-222">Transferencia · Mercado Pago · Tarjeta</span>
          </div>
        </div>
      </div>
    </section>;
}